/**
 * 学历枚举
 */
export default Object.freeze(['研究生', '本科', '专科', '其他'])